import { ShieldCheck, RefreshCw } from "lucide-react";
import { CONFIG } from "../../config";

export default function Guarantee() {
  return (
    <section className="relative py-12 sm:py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="panel p-6 sm:p-10 relative overflow-hidden text-center"
          style={{ borderColor: "rgba(0,255,136,.35)" }}>
          <div className="absolute inset-0 pointer-events-none"
            style={{ background: "radial-gradient(circle at 50% 0%, rgba(0,255,136,.08), transparent 60%)" }} />
          <div className="relative">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full grid place-items-center mx-auto mb-5"
              style={{ background: "linear-gradient(135deg, rgba(0,255,136,.18), rgba(0,255,136,.04))", border: "1px solid rgba(0,255,136,.4)" }}>
              <ShieldCheck className="w-8 h-8 sm:w-10 sm:h-10 text-[color:var(--green)]" />
            </div>
            <div className="font-mono text-[10px] sm:text-[11px] uppercase tracking-widest text-[color:var(--green)]">
              {CONFIG.GUARANTEE_DAYS}-day money-back guarantee
            </div>
            <h3 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-3 leading-tight">
              Buy risk-free.
            </h3>
            <p className="text-sm sm:text-base text-[color:var(--ink-dim)] mt-4 max-w-xl mx-auto leading-relaxed">
              Try the EA on your demo account for {CONFIG.GUARANTEE_DAYS} days. If it doesn't fit your
              workflow — for any reason — email us and we refund the full amount. No questions, no hoops,
              no fine print.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#23232a] text-[11px] sm:text-xs font-mono uppercase tracking-widest text-[color:var(--ink-dim)]">
              <RefreshCw className="w-3.5 h-3.5 text-[color:var(--green)]" /> Refund processed in 48 hours
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
